/**
 * Partnerprogramm im Dashboard-Kontext.
 * - Noch kein Affiliate-Account: zeigt die Landingpage (mit Anmelde-Dialog).
 * - Aktiver Affiliate: Onboarding-orientierte Übersicht mit
 *   Erklärung, Rabattcode-Karte, fertigen Produkt-Links, KPIs und FAQ.
 *
 * Zielgruppe sind pädagogische Fachkräfte – jede Sektion erklärt
 * in einfacher Sprache, was die Nutzerin damit tun kann.
 */
import StudentLayout from "@/components/student/StudentLayout";
import PartnerLanding from "@/pages/PartnerLanding";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useMyAffiliate } from "@/hooks/useMyAffiliate";
import { Loader2 } from "lucide-react";
import PartnerOverview from "@/components/partner/PartnerOverview";

const StudentPartnerprogramm = () => {
  const { data: user, isLoading: userLoading } = useCurrentUser();
  const { data: affiliate, isLoading: affLoading } = useMyAffiliate(user?.id);

  const isActivePartner = affiliate?.status === "active" || affiliate?.status === "pending";

  return (
    <StudentLayout>
      {userLoading || affLoading ? (
        <div className="flex min-h-[50vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : isActivePartner && affiliate ? (
        <PartnerOverview affiliateId={affiliate.id} code={affiliate.affiliate_code} />
      ) : (
        <PartnerLanding />
      )}
    </StudentLayout>
  );
};

export default StudentPartnerprogramm;
